<template>
  <div id="app">
      <header v-if="currentUser" class="app-header app-header-dark">
          <div class="top-bar">
              <div class="top-bar-list">
                  <!-- <div class="top-bar-item px-2 d-md-none d-lg-none d-xl-none">
              <button class="hamburger hamburger-squeeze" type="button" v-b-toggle.navsidebar>
                <span class="hamburger-box">
                  <span class="hamburger-inner"></span>
                </span>
              </button>
            </div> -->
                  <div class="top-bar-item" style="font-size: 20px;">
                      <img :src="require('./assets/Perftech_Kocka.jpg')" style="max-height: 35px; margin-left: -15px; margin-right:5px; paggin-bottom:20px;">
                      <strong style="padding-top:10px;">DocSayMobile<br /><p style="font-size:8px; text-align:left; margin-top: -2px">Verzija {{ version }}</p></strong>
                      
                  </div>
                  <div class="top-bar-item top-bar-item-right">
                      {{ currentUser.uporabnikIme}}
                      <b-button @click="logOut" variant="outline-secondary"><b-icon icon="box-arrow-right"></b-icon></b-button>
                  </div>
              </div>
          </div>
      </header>
    <!-- <b-sidebar id="navsidebar" v-if="currentUser">
      <aside>
        <div class="aside-content">
          <header class="aside-header d-block d-md-none text-left" style="padding:1rem">
            <span class="account-summary">
              <span class="account-name">{{currentUser.uporabnikIme}}</span>
            </span>
            <b-button @click="logOut" id="btnLogout" class="float-right" variant="outline-primary" size="sm">Logout</b-button>
          </header>
          <div class="aside-menu overflow-hidden">
            <nav id="stacked-menu" class="stacked-menu">
              <ul class="menu text-left">
                <li class="menu-item">
                  <router-link to="/" title="Čakalna vrsta" class="menu-link">
                    <span class="h3 mr-2">
                      <b-icon icon="card-checklist"></b-icon>
                    </span>
                    <span class="menu-text">Čakalna vrsta</span>
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </aside>
    </b-sidebar> -->
    <main class="app-main">
      <div class="wrapper">
        <div class="page">
          <div class="page-inner">
            <div class="page-section">
              <router-view />
            </div>
          </div>
        </div>
      </div>
      <footer></footer>
    </main>
  </div>
</template>

<script>
export default {
  computed: {
    currentUser() {
      if(this.$store.state.auth.status.loggedIn)
        return this.$store.state.auth.user.user;
      else
        return null;
    },
    version() {
        return this.$store.state.app.version;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    getVersion() {
        if (this.$store.state.app.version == undefined) {
            this.$store.dispatch("app/getVersion");
        }
    }
  },
  created() {
      this.getVersion()
  }
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.card {
  margin: 1rem;
}

.k-animation-container{
  z-index: 10110 !important
}

.top-bar-item {
    padding: 0 2rem !important;
}

</style>


<style scoped>
svg {
  font-size: 100% !important;
}

.btn-outline-secondary {
  color: #FAFAFA;
  border-color: #FAFAFA;
  margin-left: 10px;
  margin-right: -15px;
  padding: 0rem .5rem !important;
  line-height: 15px;
  height: 25px;
}
</style>